import { markRaw, toRaw } from 'vue'
import { set, get } from 'lodash'
import { applyPatch, compare } from 'fast-json-patch'

export default function createPiniaPlugin(router) {
  return ({ store }) => {
    if (router) {
      store.router = markRaw(router)
    }

    store.$deepPatch = function (path, newData) {
      const data = get(store.$state, path)
      if (data === null || data === undefined) {
        set(store.$state, path, newData)
      } else {
        const patches = compare(toRaw(data), newData)
        applyPatch(data, patches)
      }
    }
  }
}
